import React, { useContext, useEffect } from "react";
import ImageContainer from "@components/imageContainer";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { Context } from "@components/useContext/context";
import { HeaderWrapper } from "./styles";

import { connect } from "react-redux";
import { useRouter } from "next/router";

// import Back from "@public/images/back-icon.svg";
import { resolvePath } from "@utils/resolvePath";
import { useOnload } from "@utils/useOnLoad";
import { appViewConfigs, useWebviewCallback, applyWebViewWithNativeHeader } from "@utils/useWebviewCallback";
import { EWebViewActions } from "@utils/types";
import { ACKO_LOGO_URL } from "@utils/constants";
import Cookies from "js-cookie";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Header = (props: any) => {
  const { isDesktop } = useContext(Context);
  const router = useRouter();
  const {
    is_visible,
    showAckoLogoOnMobile = false,
    mStyles,
    children,
    actions,
    styles,
    showRightButton = false,
    rightButtonContent,
    rightButtonStyles = {},
    rightButtonDesktopStyles = {}
  } = props;

  const { on_load, rightButtonOnClick } = actions || {};
  const nativeHeaderHeight = Cookies.get('native_header_height')

  useOnload({ on_load });

  const useCustomBack = () => {
    router.back();
  };


  const handleRightButtonClick = () => {
    rightButtonOnClick?.forEach((eachFunc: any) => {
      console.log("eachFunc", eachFunc);
      if (typeof eachFunc.funCall === "function") {
        eachFunc.funCall(eachFunc.args);
      }
    });
  };

  const goBack = () => {
    try {
      useWebviewCallback(
        {
          action: EWebViewActions.CAN_USE_NATIVE_BACK_PRESS,
          action_value: {}
        },
        () => {
          useCustomBack();
        },
        (res: any) => {
          if (res === true) {
            useWebviewCallback(
              {
                action: EWebViewActions.NATIVE_BACK_PRESS,
                action_value: {}
              },
              () => {
                useCustomBack();
              }
            );
          } else useCustomBack();
        }
      );
    } catch (e) {
      console.log("Catch", e);
      router.back();
    }
  };

  useEffect(() => {
    applyWebViewWithNativeHeader(appViewConfigs.FRESH_CAR)
  }, [])


  return is_visible ? (
    <HeaderWrapper
      className="main-container"
      style={{
        borderColor: "rgb(230, 234, 240)",
        ...styles,
      }}
      mStyles={mStyles}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        style={{
          maxWidth: "1170px",
          margin: "auto",
          height: nativeHeaderHeight ? "0" : "56px",
          marginBottom: "4px",
          ...styles,
        }}
      >
        {isDesktop || showAckoLogoOnMobile ? (
          <a href={process.env.HOST_URL}>
            <img
              src={ACKO_LOGO_URL}
              alt="url"
              style={
                isDesktop
                  ? { height: "28px", width: "auto" }
                  : { height: "20px", width: "auto", margin: "20px" }
              }
            />
          </a>
        ) : (
          !nativeHeaderHeight ? <>
            <div
              onClick={() => goBack()}
              style={{ cursor: "pointer", marginLeft: "8px" }}
            >
              <ImageContainer
                imgSrc={resolvePath("/images/back-icon.svg")}
                alt="url"
                width={32}
                height={28}
              />
            </div>
            {
              showRightButton && (
                <div
                  onClick={handleRightButtonClick}
                  style={isDesktop ? rightButtonDesktopStyles : rightButtonStyles}
                >
                  {rightButtonContent}
                </div>
              )
            }
          </> : null
        )}
      </Flex>
      <style jsx>{`
        .main-container {
          width: 100%;
        }
      `}</style>
      {children}
    </HeaderWrapper>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(Header);
